export enum SalesMeetingStatus {
  Waiting = "waiting",
  Won = "won",
  Valuation = "valuation",
  Lost = "lost",
  Canceled = "canceledByConsumer",
  Prepared = "prepared",
}
